import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { NgxFfmService } from '../../../ngx-ffm.service';

@Component({
  selector: 'lib-selected-files-dialog',
  templateUrl: './selected-files-dialog.component.html',
  styleUrls: ['./selected-files-dialog.component.css']
})
export class SelectedFilesDialogComponent implements OnInit {
  @ViewChild('sortFiles', { static: false }) sorfFiles;
  displayFilesColumns = ['cbox', 'filename', 'delete'];
  arrFiles = [];
  arrSelectedFiles = [];
  dsSelectedFiles;
  noFiles = false;
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private ngxFfmService: NgxFfmService) { }

  ngOnInit(): void {
    this.data.forEach(element => {
      this.arrFiles.push({ name: element, select: false });
    });
    this.dsSelectedFiles = new MatTableDataSource(this.arrFiles);
    this.arrFiles.sort = this.sorfFiles;
  }

  btnDeleteFile_Click() {
    this.ngxFfmService.setFiles(this.arrSelectedFiles);
    this.arrSelectedFiles.forEach(data => {
      this.arrFiles.splice(this.arrFiles.indexOf(data), 1);
    });
    this.dsSelectedFiles = new MatTableDataSource(this.arrFiles);
    this.dsSelectedFiles.sort = this.sorfFiles;

    if (this.arrFiles.length === 0) {
      this.noFiles = true;
    } else {
      this.noFiles = false;
    }
  }

  rowSelected(element) {
    const select = !element.select;
    this.arrFiles.forEach(data => {
      if (element.name === data.name) {
        element.select = select;
      }
    });

    if (select) {
      this.arrSelectedFiles.push(element);
    } else {
      this.arrSelectedFiles.splice(this.arrSelectedFiles.indexOf(element), 1);
    }

  }

  slFile_Selected(event, element) {

    if (event.checked) {
      this.arrSelectedFiles.push(element);
    } else {
      this.arrSelectedFiles.splice(this.arrSelectedFiles.indexOf(element), 1);
    }

    this.arrFiles.forEach(data => {
      if (element.name === data.name) {
        element.select = event.checked;
      }
    });
  }

}
